(function() {
  "use strict";
  var n, l$1, u$1, i$1, o$2, r$1, f$1, c$1 = {}, s$1 = [], a$1 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, v$1 = Array.isArray;
  function h$1(n2, l2) {
    for (var u2 in l2)
      n2[u2] = l2[u2];
    return n2;
  }
  function p$1(n2) {
    var l2 = n2.parentNode;
    l2 && l2.removeChild(n2);
  }
  function y(l2, u2, t2) {
    var i2, o2, r2, f2 = {};
    for (r2 in u2)
      "key" == r2 ? i2 = u2[r2] : "ref" == r2 ? o2 = u2[r2] : f2[r2] = u2[r2];
    if (arguments.length > 2 && (f2.children = arguments.length > 3 ? n.call(arguments, 2) : t2), "function" == typeof l2 && null != l2.defaultProps)
      for (r2 in l2.defaultProps)
        void 0 === f2[r2] && (f2[r2] = l2.defaultProps[r2]);
    return d$1(l2, f2, i2, o2, null);
  }
  function d$1(n2, t2, i2, o2, r2) {
    var f2 = { type: n2, props: t2, key: i2, ref: o2, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: null == r2 ? ++u$1 : r2 };
    return null == r2 && null != l$1.vnode && l$1.vnode(f2), f2;
  }
  function k$1(n2) {
    return n2.children;
  }
  function b$1(n2, l2) {
    this.props = n2, this.context = l2;
  }
  function g$2(n2, l2) {
    if (null == l2)
      return n2.__ ? g$2(n2.__, n2.__.__k.indexOf(n2) + 1) : null;
    for (var u2; l2 < n2.__k.length; l2++)
      if (null != (u2 = n2.__k[l2]) && null != u2.__e)
        return u2.__d || u2.__e;
    return "function" == typeof n2.type ? g$2(n2) : null;
  }
  function m$1(n2) {
    var l2, u2;
    if (null != (n2 = n2.__) && null != n2.__c) {
      for (n2.__e = n2.__c.base = null, l2 = 0; l2 < n2.__k.length; l2++)
        if (null != (u2 = n2.__k[l2]) && null != u2.__e) {
          n2.__e = n2.__c.base = u2.__e;
          break;
        }
      return m$1(n2);
    }
  }
  function w$2(n2) {
    (!n2.__d && (n2.__d = true) && i$1.push(n2) && !x.__r++ || o$2 !== l$1.debounceRendering) && ((o$2 = l$1.debounceRendering) || r$1)(x);
  }
  function x() {
    var n2, l2, u2, t2, o2, r2, e2, c2, s2;
    for (i$1.sort(f$1); n2 = i$1.shift(); )
      n2.__d && (l2 = i$1.length, t2 = void 0, o2 = void 0, r2 = void 0, c2 = (e2 = (u2 = n2).__v).__e, (s2 = u2.__P) && (t2 = [], o2 = [], (r2 = h$1({}, e2)).__v = e2.__v + 1, z$1(s2, e2, r2, u2.__n, void 0 !== s2.ownerSVGElement, null != e2.__h ? [c2] : null, t2, null == c2 ? g$2(e2) : c2, e2.__h, o2), L$1(t2, e2, o2), e2.__e != c2 && m$1(e2)), i$1.length > l2 && i$1.sort(f$1));
    x.__r = 0;
  }
  function P(n2, l2, u2, t2, i2, o2, r2, f2, e2, a2, h2) {
    var p2, y2, _2, b2, m2, w2, x2, P2, C2, D2 = 0, H2 = t2 && t2.__k || s$1, I2 = H2.length, T2 = I2, j2 = l2.length;
    for (u2.__k = [], p2 = 0; p2 < j2; p2++)
      null != (b2 = u2.__k[p2] = null == (b2 = l2[p2]) || "boolean" == typeof b2 || "function" == typeof b2 ? null : "string" == typeof b2 || "number" == typeof b2 || "bigint" == typeof b2 ? d$1(null, b2, null, null, b2) : v$1(b2) ? d$1(k$1, { children: b2 }, null, null, null) : b2.__b > 0 ? d$1(b2.type, b2.props, b2.key, b2.ref ? b2.ref : null, b2.__v) : b2) ? (b2.__ = u2, b2.__b = u2.__b + 1, -1 === (P2 = A(b2, H2, x2 = p2 + D2, T2)) ? _2 = c$1 : (_2 = H2[P2] || c$1, H2[P2] = void 0, T2--), z$1(n2, b2, _2, i2, o2, r2, f2, e2, a2, h2), m2 = b2.__e, (y2 = b2.ref) && _2.ref != y2 && (_2.ref && N(_2.ref, null, b2), h2.push(y2, b2.__c || m2, b2)), null != m2 && (null == w2 && (w2 = m2), (C2 = _2 === c$1 || null === _2.__v) ? -1 == P2 && D2-- : P2 !== x2 && (P2 === x2 + 1 ? D2++ : P2 > x2 ? T2 > j2 - x2 ? D2 += P2 - x2 : D2-- : D2 = P2 < x2 && P2 == x2 - 1 ? P2 - x2 : 0), x2 = p2 + D2, "function" != typeof b2.type || P2 === x2 && _2.__k !== b2.__k ? "function" == typeof b2.type || P2 === x2 && !C2 ? void 0 !== b2.__d ? (e2 = b2.__d, b2.__d = void 0) : e2 = m2.nextSibling : e2 = S(n2, m2, e2) : e2 = $$1(b2, e2, n2), "function" == typeof u2.type && (u2.__d = e2))) : (_2 = H2[p2]) && null == _2.key && _2.__e && (_2.__e == e2 && (_2.__ = t2, e2 = g$2(_2)), O(_2, _2, false), H2[p2] = null);
    for (u2.__e = w2, p2 = I2; p2--; )
      null != H2[p2] && ("function" == typeof u2.type && null != H2[p2].__e && H2[p2].__e == u2.__d && (u2.__d = H2[p2].__e.nextSibling), O(H2[p2], H2[p2]));
  }
  function $$1(n2, l2, u2) {
    for (var t2, i2 = n2.__k, o2 = 0; i2 && o2 < i2.length; o2++)
      (t2 = i2[o2]) && (t2.__ = n2, l2 = "function" == typeof t2.type ? $$1(t2, l2, u2) : S(u2, t2.__e, l2));
    return l2;
  }
  function C$1(n2, l2) {
    return l2 = l2 || [], null == n2 || "boolean" == typeof n2 || (v$1(n2) ? n2.some(function(n3) {
      C$1(n3, l2);
    }) : l2.push(n2)), l2;
  }
  function S(n2, l2, u2) {
    return null == u2 || u2.parentNode !== n2 ? n2.insertBefore(l2, null) : l2 == u2 && null != l2.parentNode || n2.insertBefore(l2, u2), l2.nextSibling;
  }
  function A(n2, l2, u2, t2) {
    var i2 = n2.key, o2 = n2.type, r2 = u2 - 1, f2 = u2 + 1, e2 = l2[u2];
    if (null === e2 || e2 && i2 == e2.key && o2 === e2.type)
      return u2;
    if (t2 > (null != e2 ? 1 : 0))
      for (; r2 >= 0 || f2 < l2.length; ) {
        if (r2 >= 0) {
          if ((e2 = l2[r2]) && i2 == e2.key && o2 === e2.type)
            return r2;
          r2--;
        }
        if (f2 < l2.length) {
          if ((e2 = l2[f2]) && i2 == e2.key && o2 === e2.type)
            return f2;
          f2++;
        }
      }
    return -1;
  }
  function D$1(n2, l2, u2, t2, i2) {
    var o2;
    for (o2 in u2)
      "children" === o2 || "key" === o2 || o2 in l2 || I$1(n2, o2, null, u2[o2], t2);
    for (o2 in l2)
      i2 && "function" != typeof l2[o2] || "children" === o2 || "key" === o2 || "value" === o2 || "checked" === o2 || u2[o2] === l2[o2] || I$1(n2, o2, l2[o2], u2[o2], t2);
  }
  function H$1(n2, l2, u2) {
    "-" === l2[0] ? n2.setProperty(l2, null == u2 ? "" : u2) : n2[l2] = null == u2 ? "" : "number" != typeof u2 || a$1.test(l2) ? u2 : u2 + "px";
  }
  function I$1(n2, l2, u2, t2, i2) {
    var o2;
    n:
      if ("style" === l2)
        if ("string" == typeof u2)
          n2.style.cssText = u2;
        else {
          if ("string" == typeof t2 && (n2.style.cssText = t2 = ""), t2)
            for (l2 in t2)
              u2 && l2 in u2 || H$1(n2.style, l2, "");
          if (u2)
            for (l2 in u2)
              t2 && u2[l2] === t2[l2] || H$1(n2.style, l2, u2[l2]);
        }
      else if ("o" === l2[0] && "n" === l2[1])
        o2 = l2 !== (l2 = l2.replace(/(PointerCapture)$|Capture$/, "$1")), l2 = l2.toLowerCase() in n2 ? l2.toLowerCase().slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + o2] = u2, u2 ? t2 ? u2.u = t2.u : (u2.u = Date.now(), n2.addEventListener(l2, o2 ? j$1 : T$1, o2)) : n2.removeEventListener(l2, o2 ? j$1 : T$1, o2);
      else if ("dangerouslySetInnerHTML" !== l2) {
        if (i2)
          l2 = l2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l2 && "height" !== l2 && "href" !== l2 && "list" !== l2 && "form" !== l2 && "tabIndex" !== l2 && "download" !== l2 && "rowSpan" !== l2 && "colSpan" !== l2 && "role" !== l2 && l2 in n2)
          try {
            n2[l2] = null == u2 ? "" : u2;
            break n;
          } catch (n3) {
          }
        "function" == typeof u2 || (null == u2 || false === u2 && "-" !== l2[4] ? n2.removeAttribute(l2) : n2.setAttribute(l2, u2));
      }
  }
  function T$1(n2) {
    var u2 = this.l[n2.type + false];
    if (n2.t) {
      if (n2.t <= u2.u)
        return;
    } else
      n2.t = Date.now();
    return u2(l$1.event ? l$1.event(n2) : n2);
  }
  function j$1(n2) {
    return this.l[n2.type + true](l$1.event ? l$1.event(n2) : n2);
  }
  function z$1(n2, u2, t2, i2, o2, r2, f2, e2, c2, s2) {
    var a2, p2, y2, d2, _2, g2, m2, w2, x2, $2, C2, S2, A2, D2, H2, I2 = u2.type;
    if (void 0 !== u2.constructor)
      return null;
    null != t2.__h && (c2 = t2.__h, e2 = u2.__e = t2.__e, u2.__h = null, r2 = [e2]), (a2 = l$1.__b) && a2(u2);
    n:
      if ("function" == typeof I2)
        try {
          if (w2 = u2.props, x2 = (a2 = I2.contextType) && i2[a2.__c], $2 = a2 ? x2 ? x2.props.value : a2.__ : i2, t2.__c ? m2 = (p2 = u2.__c = t2.__c).__ = p2.__E : ("prototype" in I2 && I2.prototype.render ? u2.__c = p2 = new I2(w2, $2) : (u2.__c = p2 = new b$1(w2, $2), p2.constructor = I2, p2.render = q$1), x2 && x2.sub(p2), p2.props = w2, p2.state || (p2.state = {}), p2.context = $2, p2.__n = i2, y2 = p2.__d = true, p2.__h = [], p2._sb = []), null == p2.__s && (p2.__s = p2.state), null != I2.getDerivedStateFromProps && (p2.__s == p2.state && (p2.__s = h$1({}, p2.__s)), h$1(p2.__s, I2.getDerivedStateFromProps(w2, p2.__s))), d2 = p2.props, _2 = p2.state, p2.__v = u2, y2)
            null == I2.getDerivedStateFromProps && null != p2.componentWillMount && p2.componentWillMount(), null != p2.componentDidMount && p2.__h.push(p2.componentDidMount);
          else {
            if (null == I2.getDerivedStateFromProps && w2 !== d2 && null != p2.componentWillReceiveProps && p2.componentWillReceiveProps(w2, $2), !p2.__e && (null != p2.shouldComponentUpdate && false === p2.shouldComponentUpdate(w2, p2.__s, $2) || u2.__v === t2.__v)) {
              for (u2.__v !== t2.__v && (p2.props = w2, p2.state = p2.__s, p2.__d = false), u2.__e = t2.__e, u2.__k = t2.__k, u2.__k.forEach(function(n3) {
                n3 && (n3.__ = u2);
              }), C2 = 0; C2 < p2._sb.length; C2++)
                p2.__h.push(p2._sb[C2]);
              p2._sb = [], p2.__h.length && f2.push(p2);
              break n;
            }
            null != p2.componentWillUpdate && p2.componentWillUpdate(w2, p2.__s, $2), null != p2.componentDidUpdate && p2.__h.push(function() {
              p2.componentDidUpdate(d2, _2, g2);
            });
          }
          if (p2.context = $2, p2.props = w2, p2.__P = n2, p2.__e = false, S2 = l$1.__r, A2 = 0, "prototype" in I2 && I2.prototype.render) {
            for (p2.state = p2.__s, p2.__d = false, S2 && S2(u2), a2 = p2.render(p2.props, p2.state, p2.context), D2 = 0; D2 < p2._sb.length; D2++)
              p2.__h.push(p2._sb[D2]);
            p2._sb = [];
          } else
            do {
              p2.__d = false, S2 && S2(u2), a2 = p2.render(p2.props, p2.state, p2.context), p2.state = p2.__s;
            } while (p2.__d && ++A2 < 25);
          p2.state = p2.__s, null != p2.getChildContext && (i2 = h$1(h$1({}, i2), p2.getChildContext())), y2 || null == p2.getSnapshotBeforeUpdate || (g2 = p2.getSnapshotBeforeUpdate(d2, _2)), P(n2, v$1(H2 = null != a2 && a2.type === k$1 && null == a2.key ? a2.props.children : a2) ? H2 : [H2], u2, t2, i2, o2, r2, f2, e2, c2, s2), p2.base = u2.__e, u2.__h = null, p2.__h.length && f2.push(p2), m2 && (p2.__E = p2.__ = null);
        } catch (n3) {
          u2.__v = null, (c2 || null != r2) && (u2.__e = e2, u2.__h = !!c2, r2[r2.indexOf(e2)] = null), l$1.__e(n3, u2, t2);
        }
      else
        null == r2 && u2.__v === t2.__v ? (u2.__k = t2.__k, u2.__e = t2.__e) : u2.__e = M(t2.__e, u2, t2, i2, o2, r2, f2, c2, s2);
    (a2 = l$1.diffed) && a2(u2);
  }
  function L$1(n2, u2, t2) {
    for (var i2 = 0; i2 < t2.length; i2++)
      N(t2[i2], t2[++i2], t2[++i2]);
    l$1.__c && l$1.__c(u2, n2), n2.some(function(u3) {
      try {
        n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
          n3.call(u3);
        });
      } catch (n3) {
        l$1.__e(n3, u3.__v);
      }
    });
  }
  function M(l2, u2, t2, i2, o2, r2, f2, e2, s2) {
    var a2, h2, y2, d2 = t2.props, _2 = u2.props, k2 = u2.type, b2 = 0;
    if ("svg" === k2 && (o2 = true), null != r2) {
      for (; b2 < r2.length; b2++)
        if ((a2 = r2[b2]) && "setAttribute" in a2 == !!k2 && (k2 ? a2.localName === k2 : 3 === a2.nodeType)) {
          l2 = a2, r2[b2] = null;
          break;
        }
    }
    if (null == l2) {
      if (null === k2)
        return document.createTextNode(_2);
      l2 = o2 ? document.createElementNS("http://www.w3.org/2000/svg", k2) : document.createElement(k2, _2.is && _2), r2 = null, e2 = false;
    }
    if (null === k2)
      d2 === _2 || e2 && l2.data === _2 || (l2.data = _2);
    else {
      if (r2 = r2 && n.call(l2.childNodes), h2 = (d2 = t2.props || c$1).dangerouslySetInnerHTML, y2 = _2.dangerouslySetInnerHTML, !e2) {
        if (null != r2)
          for (d2 = {}, b2 = 0; b2 < l2.attributes.length; b2++)
            d2[l2.attributes[b2].name] = l2.attributes[b2].value;
        (y2 || h2) && (y2 && (h2 && y2.__html == h2.__html || y2.__html === l2.innerHTML) || (l2.innerHTML = y2 && y2.__html || ""));
      }
      if (D$1(l2, _2, d2, o2, e2), y2)
        u2.__k = [];
      else if (P(l2, v$1(b2 = u2.props.children) ? b2 : [b2], u2, t2, i2, o2 && "foreignObject" !== k2, r2, f2, r2 ? r2[0] : t2.__k && g$2(t2, 0), e2, s2), null != r2)
        for (b2 = r2.length; b2--; )
          null != r2[b2] && p$1(r2[b2]);
      e2 || ("value" in _2 && void 0 !== (b2 = _2.value) && (b2 !== l2.value || "progress" === k2 && !b2 || "option" === k2 && b2 !== d2.value) && I$1(l2, "value", b2, d2.value, false), "checked" in _2 && void 0 !== (b2 = _2.checked) && b2 !== l2.checked && I$1(l2, "checked", b2, d2.checked, false));
    }
    return l2;
  }
  function N(n2, u2, t2) {
    try {
      "function" == typeof n2 ? n2(u2) : n2.current = u2;
    } catch (n3) {
      l$1.__e(n3, t2);
    }
  }
  function O(n2, u2, t2) {
    var i2, o2;
    if (l$1.unmount && l$1.unmount(n2), (i2 = n2.ref) && (i2.current && i2.current !== n2.__e || N(i2, null, u2)), null != (i2 = n2.__c)) {
      if (i2.componentWillUnmount)
        try {
          i2.componentWillUnmount();
        } catch (n3) {
          l$1.__e(n3, u2);
        }
      i2.base = i2.__P = null, n2.__c = void 0;
    }
    if (i2 = n2.__k)
      for (o2 = 0; o2 < i2.length; o2++)
        i2[o2] && O(i2[o2], u2, t2 || "function" != typeof n2.type);
    t2 || null == n2.__e || p$1(n2.__e), n2.__ = n2.__e = n2.__d = void 0;
  }
  function q$1(n2, l2, u2) {
    return this.constructor(n2, u2);
  }
  function B$2(u2, t2, i2) {
    var o2, r2, f2, e2;
    l$1.__ && l$1.__(u2, t2), r2 = (o2 = "function" == typeof i2) ? null : i2 && i2.__k || t2.__k, f2 = [], e2 = [], z$1(t2, u2 = (!o2 && i2 || t2).__k = y(k$1, null, [u2]), r2 || c$1, c$1, void 0 !== t2.ownerSVGElement, !o2 && i2 ? [i2] : r2 ? null : t2.firstChild ? n.call(t2.childNodes) : null, f2, !o2 && i2 ? i2 : r2 ? r2.__e : t2.firstChild, o2, e2), L$1(f2, u2, e2);
  }
  n = s$1.slice, l$1 = { __e: function(n2, l2, u2, t2) {
    for (var i2, o2, r2; l2 = l2.__; )
      if ((i2 = l2.__c) && !i2.__)
        try {
          if ((o2 = i2.constructor) && null != o2.getDerivedStateFromError && (i2.setState(o2.getDerivedStateFromError(n2)), r2 = i2.__d), null != i2.componentDidCatch && (i2.componentDidCatch(n2, t2 || {}), r2 = i2.__d), r2)
            return i2.__E = i2;
        } catch (l3) {
          n2 = l3;
        }
    throw n2;
  } }, u$1 = 0, b$1.prototype.setState = function(n2, l2) {
    var u2;
    u2 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = h$1({}, this.state), "function" == typeof n2 && (n2 = n2(h$1({}, u2), this.props)), n2 && h$1(u2, n2), null != n2 && this.__v && (l2 && this._sb.push(l2), w$2(this));
  }, b$1.prototype.forceUpdate = function(n2) {
    this.__v && (this.__e = true, n2 && this.__h.push(n2), w$2(this));
  }, b$1.prototype.render = k$1, i$1 = [], r$1 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f$1 = function(n2, l2) {
    return n2.__v.__b - l2.__v.__b;
  }, x.__r = 0;
  const style = ".fc_retainley_wallet_strip {\n    background-color: black;\n    color: white;\n    font-size: 11px;\n    padding: 2.5px 0;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n}\n\n.fc_retainley_wallet_strip img {\n    height: 15px;\n}\n\n.fc_retainley_main {\n    border-radius: 5px;\n    overflow: hidden;\n    height: fit-content;\n}\n\n.fc_retainley_coin_name {\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    font-weight: 800;\n    font-size: 16px;\n}\n\n.fc_retainley_coin_name img {\n    height: 20px;\n}\n\n.fc_retainley_cart_widget {\n    background-color: rgba(110, 44, 215, 0.799);\n    color: black;\n    padding: .8rem 1rem 1.2rem 1rem;\n}\n\n.fc_retainley_wallet_message {\n    font-size: 11.8px;\n    line-height: 17px;\n    margin-top: 2px;\n    font-weight: 500;\n}\n\n.fc_retainley_remaining_balance {\n    font-size: 11.5px;\n    margin-top: -4px;\n}\n\n.fc_retainley_widget_btns_container {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 6px;\n}\n\n.fc_retainley_btn {\n    font-size: 10px;\n    font-size: 10px;\n    padding: 8px 10px;\n    border-radius: 20px;\n    cursor: pointer;\n    border: none;\n    background: #000000;\n    font-weight: 600;\n    color: white;\n}\n\n.fc_retainley_bottom {\n    margin-top: 2px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n}\n\n@media(min-width:768px) {\n    .fc_retainley_wallet_strip {\n        font-size: 13px;\n        padding: 2px 0;\n    }\n\n    .fc_retainley_coin_name {\n        font-size: 17px;\n    }\n\n    .fc_retainley_wallet_strip img {\n        height: 16px;\n    }\n\n    .fc_retainley_wallet_message {\n        font-size: 13.3px;\n        line-height: 17px;\n    }\n\n    .fc_retainley_remaining_balance {\n        font-size: 12px;\n    }\n\n    .fc_retainley_btn {\n        font-size: 11.5px;\n        padding: 10px;\n        border-radius: 20px;\n\n    }\n\n}\n\n.fc_retainley_btn_coupon_applied {\n    background-color: #006c00;\n    color: white;\n}\n\n.fc_retainley_btn_coupon_remove {\n    background: #dd0000;\n}\n\n.fc_retainley_btn_coupon_remove:hover {\n    background: #c70000;\n}\n\n.fc_retainley_btn_less_opacity {\n    /* opacity: .5; */\n    cursor: no-drop;\n    padding: 6px;\n}\n\np {\n    margin: 0;\n    padding: 0;\n}\n\n\n\n.loader {\n    width: 12px;\n    padding: 4px;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    background: #ffffff;\n    --_m:\n        conic-gradient(#0000 10%, #000),\n        linear-gradient(#000 0 0) content-box;\n    -webkit-mask: var(--_m);\n    mask: var(--_m);\n    -webkit-mask-composite: source-out;\n    mask-composite: subtract;\n    animation: l3 1s infinite linear;\n}\n\n.loader-remove {\n    width: 12px;\n    padding: 4px;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    background: #ffffff;\n    --_m:\n        conic-gradient(#0000 10%, #000),\n        linear-gradient(#000 0 0) content-box;\n    -webkit-mask: var(--_m);\n    mask: var(--_m);\n    -webkit-mask-composite: source-out;\n    mask-composite: subtract;\n    animation: l3 1s infinite linear;\n}\n\n@keyframes l3 {\n    to {\n        transform: rotate(1turn)\n    }\n}\n\n\n\n\n/* bhai ka style */\n\n.notification-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    width: 100%;\n    margin-left: -2.4rem;\n}\n\n.notification-alert {\n    display: flex;\n    align-items: center;\n    font-size: 10.5px;\n    color: #ffffff;\n    line-height: 15px;\n    width: 325px;\n    background-color: #181818;\n    padding: 5px 10px;\n    border-radius: 5px;\n    opacity: 0;\n    transform: translateY(-20px);\n    animation: fadeInUp 0.5s ease-out forwards;\n    width: fit-content;\n    margin: auto;\n    max-width: 300px;\n    text-align: center;\n}\n\n@keyframes fadeInUp {\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}";
  var t, r, u, i, o$1 = 0, f = [], c = [], e = l$1.__b, a = l$1.__r, v = l$1.diffed, l = l$1.__c, m = l$1.unmount;
  function d(t2, u2) {
    l$1.__h && l$1.__h(r, t2, o$1 || u2), o$1 = 0;
    var i2 = r.__H || (r.__H = { __: [], __h: [] });
    return t2 >= i2.__.length && i2.__.push({ __V: c }), i2.__[t2];
  }
  function h(n2) {
    return o$1 = 1, s(B$1, n2);
  }
  function s(n2, u2, i2) {
    var o2 = d(t++, 2);
    if (o2.t = n2, !o2.__c && (o2.__ = [i2 ? i2(u2) : B$1(void 0, u2), function(n3) {
      var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n3);
      t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
    }], o2.__c = r, !r.u)) {
      var f2 = function(n3, t2, r2) {
        if (!o2.__c.__H)
          return true;
        var u3 = o2.__c.__H.__.filter(function(n4) {
          return n4.__c;
        });
        if (u3.every(function(n4) {
          return !n4.__N;
        }))
          return !c2 || c2.call(this, n3, t2, r2);
        var i3 = false;
        return u3.forEach(function(n4) {
          if (n4.__N) {
            var t3 = n4.__[0];
            n4.__ = n4.__N, n4.__N = void 0, t3 !== n4.__[0] && (i3 = true);
          }
        }), !(!i3 && o2.__c.props === n3) && (!c2 || c2.call(this, n3, t2, r2));
      };
      r.u = true;
      var c2 = r.shouldComponentUpdate, e2 = r.componentWillUpdate;
      r.componentWillUpdate = function(n3, t2, r2) {
        if (this.__e) {
          var u3 = c2;
          c2 = void 0, f2(n3, t2, r2), c2 = u3;
        }
        e2 && e2.call(this, n3, t2, r2);
      }, r.shouldComponentUpdate = f2;
    }
    return o2.__N || o2.__;
  }
  function p(u2, i2) {
    var o2 = d(t++, 3);
    !l$1.__s && z(o2.__H, i2) && (o2.__ = u2, o2.i = i2, r.__H.__h.push(o2));
  }
  function b() {
    for (var t2; t2 = f.shift(); )
      if (t2.__P && t2.__H)
        try {
          t2.__H.__h.forEach(k), t2.__H.__h.forEach(w$1), t2.__H.__h = [];
        } catch (r2) {
          t2.__H.__h = [], l$1.__e(r2, t2.__v);
        }
  }
  l$1.__b = function(n2) {
    r = null, e && e(n2);
  }, l$1.__r = function(n2) {
    a && a(n2), t = 0;
    var i2 = (r = n2.__c).__H;
    i2 && (u === r ? (i2.__h = [], r.__h = [], i2.__.forEach(function(n3) {
      n3.__N && (n3.__ = n3.__N), n3.__V = c, n3.__N = n3.i = void 0;
    })) : (i2.__h.forEach(k), i2.__h.forEach(w$1), i2.__h = [], t = 0)), u = r;
  }, l$1.diffed = function(t2) {
    v && v(t2);
    var o2 = t2.__c;
    o2 && o2.__H && (o2.__H.__h.length && (1 !== f.push(o2) && i === l$1.requestAnimationFrame || ((i = l$1.requestAnimationFrame) || j)(b)), o2.__H.__.forEach(function(n2) {
      n2.i && (n2.__H = n2.i), n2.__V !== c && (n2.__ = n2.__V), n2.i = void 0, n2.__V = c;
    })), u = r = null;
  }, l$1.__c = function(t2, r2) {
    r2.some(function(t3) {
      try {
        t3.__h.forEach(k), t3.__h = t3.__h.filter(function(n2) {
          return !n2.__ || w$1(n2);
        });
      } catch (u2) {
        r2.some(function(n2) {
          n2.__h && (n2.__h = []);
        }), r2 = [], l$1.__e(u2, t3.__v);
      }
    }), l && l(t2, r2);
  }, l$1.unmount = function(t2) {
    m && m(t2);
    var r2, u2 = t2.__c;
    u2 && u2.__H && (u2.__H.__.forEach(function(n2) {
      try {
        k(n2);
      } catch (n3) {
        r2 = n3;
      }
    }), u2.__H = void 0, r2 && l$1.__e(r2, u2.__v));
  };
  var g$1 = "function" == typeof requestAnimationFrame;
  function j(n2) {
    var t2, r2 = function() {
      clearTimeout(u2), g$1 && cancelAnimationFrame(t2), setTimeout(n2);
    }, u2 = setTimeout(r2, 100);
    g$1 && (t2 = requestAnimationFrame(r2));
  }
  function k(n2) {
    var t2 = r, u2 = n2.__c;
    "function" == typeof u2 && (n2.__c = void 0, u2()), r = t2;
  }
  function w$1(n2) {
    var t2 = r;
    n2.__c = n2.__(), r = t2;
  }
  function z(n2, t2) {
    return !n2 || n2.length !== t2.length || t2.some(function(t3, r2) {
      return t3 !== n2[r2];
    });
  }
  function B$1(n2, t2) {
    return "function" == typeof t2 ? t2(n2) : t2;
  }
  var _ = 0;
  function o(o2, e2, n2, t2, f2, l2) {
    var s2, u2, a2 = {};
    for (u2 in e2)
      "ref" == u2 ? s2 = e2[u2] : a2[u2] = e2[u2];
    var i2 = { type: o2, props: a2, key: n2, ref: s2, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: --_, __source: f2, __self: l2 };
    if ("function" == typeof o2 && (s2 = o2.defaultProps))
      for (u2 in s2)
        void 0 === a2[u2] && (a2[u2] = s2[u2]);
    return l$1.vnode && l$1.vnode(i2), i2;
  }
  const WALLET_API_URI$3 = "https://fastloyaltyapi.farziengineer.co";
  const Strip = ({
    customerId,
    clientId,
    coinName
  }) => {
    const [cashbackAmount, setCashbackAmount] = h(0);
    window.fc_retainley_widget_update_strip_amount = async () => {
      var _a;
      const cartRes = await fetch(`/cart.json?v=${Date.now()}`);
      const cartDetails = await cartRes.json();
      const cartTotal = (cartDetails == null ? void 0 : cartDetails.total_price) / 100;
      const orderCashback = await fetch(`${WALLET_API_URI$3}/get-order-cashback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          client_id: clientId,
          customer_id: customerId,
          order_amount: cartTotal,
          coupon: ""
        })
      });
      const orderCashbackData = await orderCashback.json();
      if ((orderCashbackData == null ? void 0 : orderCashbackData.status) == "success") {
        setCashbackAmount((_a = orderCashbackData == null ? void 0 : orderCashbackData.data) == null ? void 0 : _a.cashbackAmount);
      }
    };
    p(() => {
      window.fc_retainley_widget_update_strip_amount();
    }, []);
    return o("div", {
      className: "fc_retainley_wallet_strip",
      children: [o("img", {
        src: "https://media.farziengineer.co/farziwallet/get-cashback.png"
      }), " ", "You'll get ", cashbackAmount, " ", coinName, " with this order."]
    });
  };
  function setCookie(name, value, daysToExpire) {
    var expires = "";
    if (daysToExpire) {
      var date = /* @__PURE__ */ new Date();
      date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1e3);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }
  function g(n2, t2) {
    for (var e2 in t2)
      n2[e2] = t2[e2];
    return n2;
  }
  function C(n2, t2) {
    for (var e2 in n2)
      if ("__source" !== e2 && !(e2 in t2))
        return true;
    for (var r2 in t2)
      if ("__source" !== r2 && n2[r2] !== t2[r2])
        return true;
    return false;
  }
  function w(n2) {
    this.props = n2;
  }
  (w.prototype = new b$1()).isPureReactComponent = true, w.prototype.shouldComponentUpdate = function(n2, t2) {
    return C(this.props, n2) || C(this.state, t2);
  };
  var R = l$1.__b;
  l$1.__b = function(n2) {
    n2.type && n2.type.__f && n2.ref && (n2.props.ref = n2.ref, n2.ref = null), R && R(n2);
  };
  var T = l$1.__e;
  l$1.__e = function(n2, t2, e2, r2) {
    if (n2.then) {
      for (var u2, o2 = t2; o2 = o2.__; )
        if ((u2 = o2.__c) && u2.__c)
          return null == t2.__e && (t2.__e = e2.__e, t2.__k = e2.__k), u2.__c(n2, t2);
    }
    T(n2, t2, e2, r2);
  };
  var F = l$1.unmount;
  function I(n2, t2, e2) {
    return n2 && (n2.__c && n2.__c.__H && (n2.__c.__H.__.forEach(function(n3) {
      "function" == typeof n3.__c && n3.__c();
    }), n2.__c.__H = null), null != (n2 = g({}, n2)).__c && (n2.__c.__P === e2 && (n2.__c.__P = t2), n2.__c = null), n2.__k = n2.__k && n2.__k.map(function(n3) {
      return I(n3, t2, e2);
    })), n2;
  }
  function L(n2, t2, e2) {
    return n2 && e2 && (n2.__v = null, n2.__k = n2.__k && n2.__k.map(function(n3) {
      return L(n3, t2, e2);
    }), n2.__c && n2.__c.__P === t2 && (n2.__e && e2.insertBefore(n2.__e, n2.__d), n2.__c.__e = true, n2.__c.__P = e2)), n2;
  }
  function U() {
    this.__u = 0, this.t = null, this.__b = null;
  }
  function D(n2) {
    var t2 = n2.__.__c;
    return t2 && t2.__a && t2.__a(n2);
  }
  function V() {
    this.u = null, this.o = null;
  }
  l$1.unmount = function(n2) {
    var t2 = n2.__c;
    t2 && t2.__R && t2.__R(), t2 && true === n2.__h && (n2.type = null), F && F(n2);
  }, (U.prototype = new b$1()).__c = function(n2, t2) {
    var e2 = t2.__c, r2 = this;
    null == r2.t && (r2.t = []), r2.t.push(e2);
    var u2 = D(r2.__v), o2 = false, i2 = function() {
      o2 || (o2 = true, e2.__R = null, u2 ? u2(l2) : l2());
    };
    e2.__R = i2;
    var l2 = function() {
      if (!--r2.__u) {
        if (r2.state.__a) {
          var n3 = r2.state.__a;
          r2.__v.__k[0] = L(n3, n3.__c.__P, n3.__c.__O);
        }
        var t3;
        for (r2.setState({ __a: r2.__b = null }); t3 = r2.t.pop(); )
          t3.forceUpdate();
      }
    }, c2 = true === t2.__h;
    r2.__u++ || c2 || r2.setState({ __a: r2.__b = r2.__v.__k[0] }), n2.then(i2, i2);
  }, U.prototype.componentWillUnmount = function() {
    this.t = [];
  }, U.prototype.render = function(n2, e2) {
    if (this.__b) {
      if (this.__v.__k) {
        var r2 = document.createElement("div"), o2 = this.__v.__k[0].__c;
        this.__v.__k[0] = I(this.__b, r2, o2.__O = o2.__P);
      }
      this.__b = null;
    }
    var i2 = e2.__a && y(k$1, null, n2.fallback);
    return i2 && (i2.__h = null), [y(k$1, null, e2.__a ? null : n2.children), i2];
  };
  var W = function(n2, t2, e2) {
    if (++e2[1] === e2[0] && n2.o.delete(t2), n2.props.revealOrder && ("t" !== n2.props.revealOrder[0] || !n2.o.size))
      for (e2 = n2.u; e2; ) {
        for (; e2.length > 3; )
          e2.pop()();
        if (e2[1] < e2[0])
          break;
        n2.u = e2 = e2[2];
      }
  };
  (V.prototype = new b$1()).__a = function(n2) {
    var t2 = this, e2 = D(t2.__v), r2 = t2.o.get(n2);
    return r2[0]++, function(u2) {
      var o2 = function() {
        t2.props.revealOrder ? (r2.push(u2), W(t2, n2, r2)) : u2();
      };
      e2 ? e2(o2) : o2();
    };
  }, V.prototype.render = function(n2) {
    this.u = null, this.o = /* @__PURE__ */ new Map();
    var t2 = C$1(n2.children);
    n2.revealOrder && "b" === n2.revealOrder[0] && t2.reverse();
    for (var e2 = t2.length; e2--; )
      this.o.set(t2[e2], this.u = [1, 0, this.u]);
    return n2.children;
  }, V.prototype.componentDidUpdate = V.prototype.componentDidMount = function() {
    var n2 = this;
    this.o.forEach(function(t2, e2) {
      W(n2, e2, t2);
    });
  };
  var B = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, H = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, Z = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, Y = /[A-Z0-9]/g, $ = "undefined" != typeof document, q = function(n2) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n2);
  };
  b$1.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t2) {
    Object.defineProperty(b$1.prototype, t2, { configurable: true, get: function() {
      return this["UNSAFE_" + t2];
    }, set: function(n2) {
      Object.defineProperty(this, t2, { configurable: true, writable: true, value: n2 });
    } });
  });
  var K = l$1.event;
  function Q() {
  }
  function X() {
    return this.cancelBubble;
  }
  function nn() {
    return this.defaultPrevented;
  }
  l$1.event = function(n2) {
    return K && (n2 = K(n2)), n2.persist = Q, n2.isPropagationStopped = X, n2.isDefaultPrevented = nn, n2.nativeEvent = n2;
  };
  var en = { enumerable: false, configurable: true, get: function() {
    return this.class;
  } }, rn = l$1.vnode;
  l$1.vnode = function(n2) {
    "string" == typeof n2.type && function(n3) {
      var t2 = n3.props, e2 = n3.type, u2 = {};
      for (var o2 in t2) {
        var i2 = t2[o2];
        if (!("value" === o2 && "defaultValue" in t2 && null == i2 || $ && "children" === o2 && "noscript" === e2 || "class" === o2 || "className" === o2)) {
          var l2 = o2.toLowerCase();
          "defaultValue" === o2 && "value" in t2 && null == t2.value ? o2 = "value" : "download" === o2 && true === i2 ? i2 = "" : "ondoubleclick" === l2 ? o2 = "ondblclick" : "onchange" !== l2 || "input" !== e2 && "textarea" !== e2 || q(t2.type) ? "onfocus" === l2 ? o2 = "onfocusin" : "onblur" === l2 ? o2 = "onfocusout" : Z.test(o2) ? o2 = l2 : -1 === e2.indexOf("-") && H.test(o2) ? o2 = o2.replace(Y, "-$&").toLowerCase() : null === i2 && (i2 = void 0) : l2 = o2 = "oninput", "oninput" === l2 && u2[o2 = l2] && (o2 = "oninputCapture"), u2[o2] = i2;
        }
      }
      "select" == e2 && u2.multiple && Array.isArray(u2.value) && (u2.value = C$1(t2.children).forEach(function(n4) {
        n4.props.selected = -1 != u2.value.indexOf(n4.props.value);
      })), "select" == e2 && null != u2.defaultValue && (u2.value = C$1(t2.children).forEach(function(n4) {
        n4.props.selected = u2.multiple ? -1 != u2.defaultValue.indexOf(n4.props.value) : u2.defaultValue == n4.props.value;
      })), t2.class && !t2.className ? (u2.class = t2.class, Object.defineProperty(u2, "className", en)) : (t2.className && !t2.class || t2.class && t2.className) && (u2.class = u2.className = t2.className), n3.props = u2;
    }(n2), n2.$$typeof = B, rn && rn(n2);
  };
  var un = l$1.__r;
  l$1.__r = function(n2) {
    un && un(n2), n2.__c;
  };
  var on = l$1.diffed;
  l$1.diffed = function(n2) {
    on && on(n2);
    var t2 = n2.props, e2 = n2.__e;
    null != e2 && "textarea" === n2.type && "value" in t2 && t2.value !== e2.value && (e2.value = null == t2.value ? "" : t2.value);
  };
  const Alert = ({
    message
  }) => {
    return o(k$1, {
      children: o("div", {
        className: "notification-container",
        children: o("div", {
          className: "notification-alert",
          children: o("span", {
            children: message
          })
        })
      })
    });
  };
  const WALLET_API_URI$2 = "https://fastloyaltyapi.farziengineer.co";
  const Widget = ({
    userBalance,
    clientLimitDetails,
    coinName,
    customerId,
    clientId,
    customerTags,
    customMessage,
    amountLoaded
  }) => {
    const [msg, setMsg] = h("Apply now to save more on your cart.");
    const [changeMsg, setChangeMsg] = h(false);
    const [couponApplying, setCouponApplying] = h(false);
    const [couponRemoving, setCouponRemoving] = h(false);
    const [retainleyCouponisApplied, setRetainleyCouponIsApplied] = h(false);
    const [remainingUserBalance, setRemainingUserBalance] = h(userBalance);
    const [showError, setShowError] = h(false);
    const getRetainleyCoupon = async () => {
      var _a, _b, _c, _d, _e;
      if (userBalance == 0) {
        setShowError("Insufficient Balance");
        await setTimeout(() => setShowError(false), 4e3);
        return;
      }
      let cartCookieId = (_b = (_a = document.cookie) == null ? void 0 : _a.trim().split("; ").find((row) => row.startsWith("cart="))) == null ? void 0 : _b.split("=")[1];
      const walletCouponResponse = await fetch(`${WALLET_API_URI$2}/loyalty/get-wallet-coupon`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          client_id: clientId,
          customer_id: customerId,
          user_hash: customerTags,
          // wallet_points: amount,
          cartId: cartCookieId
        })
      });
      const walletCouponData = await walletCouponResponse.json();
      if ((walletCouponData == null ? void 0 : walletCouponData.status) == "success") {
        window.fc_retainley_coupon_amount = (_c = walletCouponData == null ? void 0 : walletCouponData.data) == null ? void 0 : _c.points;
        window.fc_retainley_coupon_code_applied = (_d = walletCouponData == null ? void 0 : walletCouponData.data) == null ? void 0 : _d.coupon_code;
        return (_e = walletCouponData == null ? void 0 : walletCouponData.data) == null ? void 0 : _e.coupon_code;
      } else {
        // console.log("coupon-code wali api-has error.", walletCouponData);
        setShowError(
          // @ts-ignore
          `Error: ${(walletCouponData == null ? void 0 : walletCouponData.error) || "Something went wrong in fetching coupon."}`
        );
        await setTimeout(() => setShowError(false), 4e3);
        return "";
      }
    };
    const handleApplyCoupon = async (coupon) => {
      var _a;
      const cartRes = await fetch(`/cart.json?v=${Date.now()}`);
      const data = await cartRes.json();
      if (((_a = data == null ? void 0 : data.cart_level_discount_applications) == null ? void 0 : _a.length) > 0) {
        const coupons = data == null ? void 0 : data.cart_level_discount_applications.map((e2) => {
          return e2.title;
        });
        let valuesToRemove = ["WALLETAPPLIED"];
        if (window.fc_coin_prefix) {
          valuesToRemove.push(window.fc_coin_prefix);
        }
        const filteredArray = coupons.filter((item) => !valuesToRemove.some((prefix) => item.startsWith(prefix)));
        let resultString = filteredArray.join(",");
        if (!resultString) {
          resultString = null;
        }
        await fetch(`/checkout/?discount=${coupon},${resultString}`, {
          method: "POST"
        });
        return true;
      } else {
        await fetch(`/checkout/?discount=${coupon}`, {
          method: "POST"
        });
        return true;
      }
    };
    const checkWeatherRetainleyCouponIsAppliedOrNot = async () => {
      const cartRes = await fetch(`/cart.json?v=${Date.now()}`);
      const cartDetails = await cartRes.json();
      const discountsArray = cartDetails == null ? void 0 : cartDetails.cart_level_discount_applications;
      if (discountsArray.length > 0) {
        let couponsToCheck = ["WALLETAPPLIED"];
        if (window.fc_coin_prefix) {
          couponsToCheck.push(window.fc_coin_prefix);
        }
        const couponCodeArray = discountsArray.map((e2) => {
          return e2.title;
        });
        const found = couponsToCheck.some((prefix) => couponCodeArray.some((item) => item.startsWith(prefix)));
        if (found == true) {
          setRetainleyCouponIsApplied(found);
          setCookie("discount_code", window.fc_retainley_coupon_code_applied, 1);
          setRemainingUserBalance(userBalance - window.fc_retainley_coupon_amount);
          setMsg(`You are saving ₹${window.fc_retainley_coupon_amount} via ${coinName}.`);
          sessionStorage.setItem("wasRetainleyCouponApplied", "true");
          window.fc_retainley_widget_update_strip_amount();
        } else {
          setCouponApplying(false);
          setShowError("Failed to apply the coupon.");
          setTimeout(() => setShowError(false), 3e3);
        }
      } else {
        setShowError(`${coinName} not applied.`);
        setTimeout(() => setShowError(false), 2500);
      }
    };
    const handleSlabCase = async () => {
      var _a, _b, _c;
      if (((_a = clientLimitDetails == null ? void 0 : clientLimitDetails.limit_details) == null ? void 0 : _a.type) == "SLABS") {
        const slabArr = (_b = clientLimitDetails == null ? void 0 : clientLimitDetails.limit_details) == null ? void 0 : _b.slabs;
        const cartRes = await fetch(`/cart.json?v=${Date.now()}`);
        const cartDetails = await cartRes.json();
        let totalPrice = (cartDetails == null ? void 0 : cartDetails.total_price) / 100;
        const currentSlab = slabArr.find((e2) => {
          return e2.min <= totalPrice && e2.max >= totalPrice;
        });
        // console.log(currentSlab, "amit slab");
        if (currentSlab.amount == 0) {
          setShowError(
            // @ts-ignore
            `Add more products to use ${coinName}.`
          );
          await setTimeout(() => setShowError(false), 4e3);
          setCookie("discount_code", "", 1);
          const cartRes2 = await fetch(`/cart.json?v=${Date.now()}`);
          const data = await cartRes2.json();
          if (((_c = data == null ? void 0 : data.cart_level_discount_applications) == null ? void 0 : _c.length) > 0) {
            const coupons = data == null ? void 0 : data.cart_level_discount_applications.map((e2) => {
              return e2.title;
            });
            const result = coupons.map((name) => name.toUpperCase());
            let valuesToRemove = ["WALLETAPPLIED"];
            if (window.fc_coin_prefix) {
              valuesToRemove.push(window.fc_coin_prefix);
            }
            const filteredArray = result.filter((item) => !valuesToRemove.some((prefix) => item.startsWith(prefix)));
            let resultString = filteredArray.join(",");
            if (!resultString) {
              resultString = null;
            }
            await fetch(`/checkout/?discount=${resultString}`, {
              method: "POST"
            });
            setRetainleyCouponIsApplied(false);
            sessionStorage.setItem("wasRetainleyCouponApplied", "false");
          }
          return "small-slab";
        }
      }
    };
    const handleApplyBtnClick = async () => {
      console.log("amit obj", {
        amountLoaded,
        clientLimitDetails,
        coinName,
        customerId,
        clientId
      });
      if (amountLoaded && clientLimitDetails && coinName && customerId && clientId) {
        setCouponApplying(true);
        await window.fc_retainley_call_function_before();
        const resp = await handleSlabCase();
        if (resp != "small-slab") {
          const coupon = await getRetainleyCoupon();
          if (coupon) {
            await handleApplyCoupon(coupon);
            await checkWeatherRetainleyCouponIsAppliedOrNot();
          }
        }
        await window.fc_retainley_amit_coupon_btn_click();
        setCouponApplying(false);
      }
    };
    const handleRemoveRetainleyCoupon = async () => {
      var _a;
      setCouponRemoving(true);
      setCookie("discount_code", "", 1);
      const cartRes = await fetch(`/cart.json?v=${Date.now()}`);
      const data = await cartRes.json();
      if (((_a = data == null ? void 0 : data.cart_level_discount_applications) == null ? void 0 : _a.length) > 0) {
        const coupons = data == null ? void 0 : data.cart_level_discount_applications.map((e2) => {
          return e2.title;
        });
        const result = coupons.map((name) => name.toUpperCase());
        let valuesToRemove = ["WALLETAPPLIED"];
        if (window.fc_coin_prefix) {
          valuesToRemove.push(window.fc_coin_prefix);
        }
        const filteredArray = result.filter((item) => !valuesToRemove.some((prefix) => item.startsWith(prefix)));
        let resultString = filteredArray.join(",");
        if (!resultString) {
          resultString = null;
        }
        await fetch(`/checkout/?discount=${resultString}`, {
          method: "POST"
        });
        setRetainleyCouponIsApplied(false);
        setCouponApplying(false);
        setChangeMsg(!changeMsg);
        sessionStorage.setItem("wasRetainleyCouponApplied", "false");
        setRemainingUserBalance(userBalance);
        setCouponRemoving(false);
        window.fc_retainley_amit_coupon_btn_click();
        window.fc_retainley_widget_update_strip_amount();
      }
    };
    p(() => {
      const getMsg = async () => {
        var _a, _b, _c, _d;
        const walletRedemptionType = (_a = clientLimitDetails == null ? void 0 : clientLimitDetails.limit_details) == null ? void 0 : _a.type;
        // console.log("amit", clientLimitDetails);
        if (customMessage) {
          setMsg(customMessage);
        } else {
          if (walletRedemptionType == "FIXED") {
            if (((_b = clientLimitDetails == null ? void 0 : clientLimitDetails.limit_details) == null ? void 0 : _b.amount) <= userBalance) {
              setMsg(`₹${(_c = clientLimitDetails == null ? void 0 : clientLimitDetails.limit_details) == null ? void 0 : _c.amount} can be paid via ${coinName}`);
            } else {
              setMsg(`₹${userBalance} can be paid via ${coinName}`);
            }
          }
          if (walletRedemptionType == "CART_PERCENT") {
            const percentage = (_d = clientLimitDetails == null ? void 0 : clientLimitDetails.limit_details) == null ? void 0 : _d.amount;
            setMsg(`${percentage}% of the cart total can be paid via ${coinName}`);
          }
          if (walletRedemptionType == "SLABS") {
            setMsg(customMessage || "Apply now to save more on your cart.");
          }
        }
      };
      getMsg();
    }, [clientLimitDetails, coinName, userBalance, changeMsg]);
    p(() => {
      setRemainingUserBalance(userBalance);
    }, [userBalance]);
    p(() => {
      const wasRetainleyCouponApplied = sessionStorage.getItem("wasRetainleyCouponApplied");
      if (wasRetainleyCouponApplied == "true") {
        if (userBalance && clientLimitDetails && coinName && customerId && clientId) {
          handleApplyBtnClick();
        }
      }
    }, [userBalance, clientLimitDetails, coinName, customerId, clientId]);
    p(() => {
      const wasRetainleyCouponApplied = sessionStorage.getItem("wasRetainleyCouponApplied");
      if (wasRetainleyCouponApplied != "true") {
        const RemoveRetainleyCouponIfApplied = async () => {
          setCookie("discount_code", "", 1);
          const cartRes = await fetch(`/cart.json?v=${Date.now()}`);
          const cartDetails = await cartRes.json();
          const discountsArray = cartDetails == null ? void 0 : cartDetails.cart_level_discount_applications;
          if (discountsArray.length > 0) {
            let couponsToCheck = ["WALLETAPPLIED"];
            if (window.fc_coin_prefix) {
              couponsToCheck.push(window.fc_coin_prefix);
            }
            const couponCodeArray = discountsArray.map((e2) => {
              return e2.title;
            });
            const found = couponsToCheck.some((prefix) => couponCodeArray.some((item) => item.startsWith(prefix)));
            if (found == true) {
              const coupons = cartDetails == null ? void 0 : cartDetails.cart_level_discount_applications.map((e2) => {
                return e2.title;
              });
              const result = coupons.map((name) => name.toUpperCase());
              let valuesToRemove = ["WALLETAPPLIED"];
              if (window.fc_coin_prefix) {
                valuesToRemove.push(window.fc_coin_prefix);
              }
              const filteredArray = result.filter((item) => !valuesToRemove.some((prefix) => item.startsWith(prefix)));
              let resultString = filteredArray.join(",");
              if (!resultString) {
                resultString = null;
              }
              await fetch(`/checkout/?discount=${resultString}`, {
                method: "POST"
              });
            }
            if (window.fc_retainley_call_function_on_cart_update) {
              window.fc_retainley_call_function_on_cart_update();
            }
          }
        };
        RemoveRetainleyCouponIfApplied();
      }
    }, [window.fc_retainley_call_function_on_cart_update]);
    return o(k$1, {
      children: o("div", {
        className: "fc_retainley_cart_widget",
        children: [showError && o(Alert, {
          message: showError
        }), o("div", {
          className: "fc_retainley_coin_name",
          children: [o("img", {
            src: "https://media.farziengineer.co/farziwallet/wallet_icon.svg"
          }), coinName]
        }), o("p", {
          className: "fc_retainley_wallet_message",
          children: msg
        }), o("div", {
          className: "fc_retainley_bottom",
          children: [o("p", {
            className: "fc_retainley_remaining_balance",
            children: ["Remaining balance: ", remainingUserBalance.toFixed(2)]
          }), o("div", {
            className: "fc_retainley_widget_btns_container",
            children: retainleyCouponisApplied ? o("button", {
              onClick: () => handleRemoveRetainleyCoupon(),
              className: couponRemoving ? "fc_retainley_btn fc_retainley_btn_coupon_remove fc_retainley_btn_less_opacity" : "fc_retainley_btn fc_retainley_btn_coupon_remove",
              children: couponRemoving ? o("div", {
                class: "loader-remove"
              }) : "Remove"
            }) : o("button", {
              onClick: () => {
                handleApplyBtnClick();
              },
              className: couponApplying ? "fc_retainley_btn fc_retainley_btn_less_opacity" : "fc_retainley_btn",
              children: couponApplying ? o("div", {
                class: "loader"
              }) : "Apply now"
            })
          })]
        })]
      })
    });
  };
  const LogoutWidget = ({
    clientLimitDetails,
    coinName,
    clientId,
    customMessage,
    customLogoutMessage,
    hideOnLogout
  }) => {
    const [msg, setMsg] = h("Save more on your cart!");
    p(() => {
      var _a, _b, _c;
      if (customMessage) {
        setMsg(customMessage);
      } else {
        const walletRedemptionType = (_a = clientLimitDetails == null ? void 0 : clientLimitDetails.limit_details) == null ? void 0 : _a.type;
        if (walletRedemptionType == "FIXED") {
          setMsg(`₹${(_b = clientLimitDetails == null ? void 0 : clientLimitDetails.limit_details) == null ? void 0 : _b.amount} can be paid via ${coinName}`);
        }
        if (walletRedemptionType == "CART_PERCENT") {
          const percentage = (_c = clientLimitDetails == null ? void 0 : clientLimitDetails.limit_details) == null ? void 0 : _c.amount;
          setMsg(`${percentage}% of the cart total can be paid via ${coinName}`);
        }
      }
    }, [clientLimitDetails, coinName]);
    const handleLogin = () => {
      if (window == null ? void 0 : window.fc_custom_login) {
        window == null ? void 0 : window.fc_custom_login();
      } else {
        window.location.href = "/account/login";
      }
    };
    p(() => {
      const RemoveRetainleyCouponForLogout = async () => {
        const cartRes = await fetch(`/cart.json?v=${Date.now()}`);
        const cartDetails = await cartRes.json();
        const discountsArray = cartDetails == null ? void 0 : cartDetails.cart_level_discount_applications;
        if (discountsArray.length > 0) {
          let couponsToCheck = ["WALLETAPPLIED"];
          if (window.fc_coin_prefix) {
            couponsToCheck.push(window.fc_coin_prefix);
          }
          const couponCodeArray = discountsArray.map((e2) => {
            return e2.title;
          });
          const found = couponsToCheck.some((prefix) => couponCodeArray.some((item) => item.startsWith(prefix)));
          if (found == true) {
            const coupons = cartDetails == null ? void 0 : cartDetails.cart_level_discount_applications.map((e2) => {
              return e2.title;
            });
            const result = coupons.map((name) => name.toUpperCase());
            let valuesToRemove = ["WALLETAPPLIED"];
            if (window.fc_coin_prefix) {
              valuesToRemove.push(window.fc_coin_prefix);
            }
            const filteredArray = result.filter((item) => !valuesToRemove.some((prefix) => item.startsWith(prefix)));
            let resultString = filteredArray.join(",");
            if (!resultString) {
              resultString = null;
            }
            await fetch(`/checkout/?discount=${resultString}`, {
              method: "POST"
            });
          }
        }
      };
      const call = async () => {
        if (window.fc_retainley_call_function_on_cart_update) {
          await window.fc_retainley_call_function_on_cart_update();
        }
      };
      const callBoth = async () => {
        await RemoveRetainleyCouponForLogout();
        await call();
      };
      callBoth();
    }, []);
    if (hideOnLogout) {
      return o(k$1, {});
    }
    return o("div", {
      className: "fc_retainley_cart_widget",
      children: [o("div", {
        className: "fc_retainley_coin_name",
        children: [o("img", {
          src: "https://media.farziengineer.co/farziwallet/wallet_icon.svg"
        }), coinName]
      }), o("p", {
        className: "fc_retainley_wallet_message",
        children: msg
      }), o("div", {
        className: "fc_retainley_bottom",
        children: [o("p", {
          className: "fc_retainley_remaining_balance",
          children: customLogoutMessage ? customLogoutMessage : `Login now to use ${coinName}`
        }), o("div", {
          className: "fc_retainley_widget_btns_container",
          children: o("button", {
            onClick: () => handleLogin(),
            className: "fc_retainley_btn",
            children: "Login now"
          })
        })]
      })]
    });
  };
  const WALLET_API_URI$1 = "https://fastloyaltyapi.farziengineer.co";
  const MainComponent = () => {
    var _a;
    const mainScript = document.querySelector("#fc-wallet-cart-widget-script-19212");
    const customer_id = mainScript.getAttribute("data-customer-id");
    const customer_tags = (_a = mainScript.getAttribute("data-customer-tag")) == null ? void 0 : _a.trim();
    const client_id = mainScript.getAttribute("data-client-id");
    const custom_message = mainScript.getAttribute("custom_message");
    const custom_logout_message = mainScript.getAttribute("custom_logout_message");
    const hide_on_logout = mainScript.getAttribute("hide_on_logout");
    const [userWalletAmount, setUserWalletAmount] = h(0);
    const [amountLoaded, setAmountLoaded] = h(false);
    const [clientLimitDetails, setClientLimitDetails] = h("");
    const [coinName, setCoinName] = h(sessionStorage.getItem("retainleyCoinName") ? sessionStorage.getItem("retainleyCoinName") : "");
    const getThemeDetails = async () => {
      var _a2, _b;
      if (!sessionStorage.getItem("retainleyCoinName")) {
        const themeDetails = await fetch(`${WALLET_API_URI$1}/get-theme-details`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            client_id
          })
        });
        const themeDetailsData = await themeDetails.json();
        sessionStorage.setItem("retainleyCoinName", (_a2 = themeDetailsData == null ? void 0 : themeDetailsData.data) == null ? void 0 : _a2.coin_name);
        setCoinName((_b = themeDetailsData == null ? void 0 : themeDetailsData.data) == null ? void 0 : _b.coin_name);
      }
    };
    const getClientWalletLimit = async () => {
      if (!window.fc_retainley_client_limit) {
        const clientWalletLimit = await fetch(`${WALLET_API_URI$1}/client-wallet-limit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            client_id
          })
        });
        const resp = await clientWalletLimit.json();
        if (resp == null ? void 0 : resp.status) {
          window.fc_retainley_client_limit = resp == null ? void 0 : resp.data;
          setClientLimitDetails(resp == null ? void 0 : resp.data);
        }
      } else {
        setClientLimitDetails(window.fc_retainley_client_limit);
      }
    };
    const getUserWalletAmount = async () => {
      var _a2, _b;
      if (!window.fc_retainley_user_wallet_amount) {
        const clientWalletLimit = await fetch(`${WALLET_API_URI$1}/user-wallet-amount`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            client_id,
            customer_id,
            customer_tags
          })
        });
        const resp = await clientWalletLimit.json();
        if ((resp == null ? void 0 : resp.status) == "success") {
          const walletAmt = (_b = (_a2 = resp == null ? void 0 : resp.data) == null ? void 0 : _a2.userWallet) == null ? void 0 : _b.amount;
          window.fc_retainley_user_wallet_amount = walletAmt;
          setUserWalletAmount(walletAmt);
          setAmountLoaded(true);
        }
      } else {
        setUserWalletAmount(window.fc_retainley_user_wallet_amount);
        setAmountLoaded(true);
      }
    };
    p(() => {
      if (customer_id) {
        getClientWalletLimit();
        getThemeDetails();
        getUserWalletAmount();
      } else {
        getClientWalletLimit();
        getThemeDetails();
      }
    }, []);
    return o("div", {
      className: "fc_retainley_main",
      children: [o(Strip, {
        coinName,
        clientId: client_id,
        customerId: customer_id
      }), customer_id ? o(Widget, {
        userBalance: userWalletAmount,
        amountLoaded,
        clientLimitDetails,
        coinName,
        customerId: customer_id,
        clientId: client_id,
        customerTags: customer_tags,
        customMessage: custom_message
      }) : o(LogoutWidget, {
        clientLimitDetails,
        coinName,
        clientId: client_id,
        customMessage: custom_message,
        customLogoutMessage: custom_logout_message,
        hideOnLogout: hide_on_logout
      })]
    });
  };
  function App() {
    return o(k$1, {
      children: [o("div", {
        class: "widget-container",
        children: o(MainComponent, {})
      }), o("div", {
        class: "widget-styles"
      }), o("div", {
        class: "widget-custom-styles"
      })]
    });
  }
  function AppCSS() {
    return o("style", {
      children: style
    });
  }
  function AppCustomCSS({
    customStyles
  }) {
    return o("style", {
      children: customStyles
    });
  }
  const WALLET_API_URI = "https://fastloyaltyapi.farziengineer.co";
  async function renderWalletBox() {
    var _a;
    try {
      const targetDiv = document.getElementById("fc-wallet-cart-widget-19212");
      targetDiv.innerHTML = "";
      let shadowTarget = document.createElement("div");
      shadowTarget.className = "fc-wallet-cart-widget-19212-target";
      shadowTarget.style.display = "block";
      targetDiv.appendChild(shadowTarget);
      let shadow = shadowTarget.attachShadow({
        mode: "open"
      });
      let shadowRoot = document.createElement("div");
      shadowRoot.className = "fc-wallet-cart-widget-19212-root";
      shadow.appendChild(shadowRoot);
      let themeDetailsData;
      if (sessionStorage.getItem("retainleyThemeDetails")) {
        themeDetailsData = JSON.parse(sessionStorage.getItem("retainleyThemeDetails"));
        // console.log("amit old", themeDetailsData);
      } else {
        const mainScript = document.querySelector("#fc-wallet-cart-widget-script-19212");
        const client_id = mainScript.getAttribute("data-client-id");
        const themeDetailsRes = await fetch(`${WALLET_API_URI}/get-theme-details?calledfromwidget=true`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            client_id
          })
        });
        themeDetailsData = await themeDetailsRes.json();
        window.fc_loyalty_vars = {
          theme_details: themeDetailsData
        };
        // console.log("amit new", themeDetailsData);
        sessionStorage.setItem("retainleyThemeDetails", JSON.stringify(themeDetailsData));
      }
      const clientCustomStyleData = ((_a = themeDetailsData == null ? void 0 : themeDetailsData.data) == null ? void 0 : _a.apply_wallet_snippet_css) || "";
      B$2(o(App, {
        themeDetailsData,
        shadowRoot
      }), shadowRoot);
      B$2(o(AppCSS, {}), shadowRoot == null ? void 0 : shadowRoot.querySelector(".widget-styles"));
      B$2(o(AppCustomCSS, {
        customStyles: clientCustomStyleData
      }), shadowRoot == null ? void 0 : shadowRoot.querySelector(".widget-custom-styles"));
    } catch (err) {
      if (err.message != "Cannot set properties of null (setting 'innerHTML')") {
        console.log(err);
      }
    }
  }
  window.fc_loyalty_render_wallet_box = renderWalletBox;
  renderWalletBox();
  function checkWalletBox() {
    setInterval(() => {
      if (document.querySelector("#fc-wallet-cart-widget-19212 .fc-wallet-cart-widget-19212-target"))
        ;
      else {
        renderWalletBox();
      }
    }, 300);
  }
  window.fc_loyalty_check_wallet_box = checkWalletBox;
  checkWalletBox();
})();
